import { createRoot } from 'react-dom/client';
// Poster type (docs/DESIGN.md): Anton for the one loud line per screen,
// Work Sans for everything else, Anek Devanagari as the fallback for Hindi
// names. Anek Latin stays for the gift keepsakes drawn on canvas.
import '@fontsource/anton/400.css';
import '@fontsource-variable/work-sans/wght.css';
import '@fontsource-variable/anek-latin/wdth.css';
import '@fontsource-variable/anek-devanagari/wdth.css';
import './index.css';
import { App } from './App';
import { installStaleBuildReload } from './lib/staleBuild';

// A tab left open across a deploy reloads into the new build instead of crashing.
installStaleBuildReload();

// DEV builds only: the e2e safety hook (see features/safety/devHook.ts). Dropped from production builds.
if (import.meta.env.DEV) void import('./features/safety/devHook');
// DEV builds only: show the quiet-moment helper on demand (see features/icebreakers/nudgeTestHook.ts).
if (import.meta.env.DEV) void import('./features/icebreakers/nudgeDevHook');

createRoot(document.getElementById('root')!).render(<App />);
